/* AltCryptoGems — Shopify Theme JS */

(function() {
  'use strict';

  /* ===== CART STATE ===== */
  const ACGCart = {
    init() {
      this.bindEvents();
      this.updateCartCount();
    },

    bindEvents() {
      // Add to cart buttons
      document.addEventListener('click', (e) => {
        const addBtn = e.target.closest('[data-add-to-cart]');
        if (addBtn) {
          e.preventDefault();
          e.stopPropagation();
          this.handleAddToCart(addBtn);
        }

        const qtyBtn = e.target.closest('[data-qty-change]');
        if (qtyBtn) {
          e.preventDefault();
          this.handleQtyChange(qtyBtn);
        }

        const removeBtn = e.target.closest('[data-remove-item]');
        if (removeBtn) {
          e.preventDefault();
          this.handleRemoveItem(removeBtn);
        }
      });

      // Variant selectors
      document.querySelectorAll('[data-option-select]').forEach(btn => {
        btn.addEventListener('click', function() {
          const group = this.closest('[data-option-group]');
          group.querySelectorAll('[data-option-select]').forEach(b => b.classList.remove('is-active'));
          this.classList.add('is-active');
        });
      });
    },

    async handleAddToCart(btn) {
      const form = btn.closest('form') || document.querySelector('product-form form');
      if (!form) return;

      const formData = new FormData(form);

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        });
        const item = await res.json();
        this.showToast(`${item.title || item.product_title} toegevoegd`);
        this.updateCartCount();
      } catch (err) {
        console.error('Add to cart failed:', err);
        this.showToast('Er ging iets mis');
      }
    },

    async handleQtyChange(btn) {
      const line = btn.dataset.line;
      const delta = parseInt(btn.dataset.qtyChange);
      const container = btn.closest('.cart-item');
      const qtyEl = container.querySelector('.qty-value');
      const currentQty = parseInt(qtyEl.textContent);
      const newQty = Math.max(0, currentQty + delta);

      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: parseInt(line), quantity: newQty }),
        });
        if (newQty === 0) {
          container.style.opacity = '0';
          container.style.transform = 'translateX(-20px)';
          setTimeout(() => location.reload(), 300);
        } else {
          location.reload();
        }
      } catch (err) {
        console.error('Qty change failed:', err);
      }
    },

    async handleRemoveItem(btn) {
      const line = btn.dataset.removeLine;
      const container = btn.closest('.cart-item');

      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: parseInt(line), quantity: 0 }),
        });
        container.style.opacity = '0';
        container.style.transform = 'translateX(-20px)';
        setTimeout(() => location.reload(), 300);
      } catch (err) {
        console.error('Remove failed:', err);
      }
    },

    async updateCartCount() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        document.querySelectorAll('.cart-count').forEach(el => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
      } catch (err) {}
    },

    showToast(msg) {
      const existing = document.querySelector('.toast');
      if (existing) existing.remove();

      const toast = document.createElement('div');
      toast.className = 'toast';
      toast.textContent = `✓ ${msg}`;
      document.body.appendChild(toast);
      setTimeout(() => toast.remove(), 2500);
    }
  };

  /* ===== SEARCH ===== */
  const ACGSearch = {
    init() {
      const input = document.querySelector('.search-input');
      if (!input) return;

      input.addEventListener('input', (e) => {
        const query = e.target.value.toLowerCase();
        document.querySelectorAll('.product-card').forEach(card => {
          const name = card.dataset.name || '';
          card.style.display = name.toLowerCase().includes(query) ? '' : 'none';
        });

        const visible = document.querySelectorAll('.product-card:not([style*="display: none"])').length;
        const countEl = document.querySelector('.filter-bar__count');
        if (countEl) countEl.textContent = `${visible} items`;
      });
    }
  };

  /* ===== INIT ===== */
  document.addEventListener('DOMContentLoaded', () => {
    ACGCart.init();
    ACGSearch.init();
  });
})();
